var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[(_vm.authenticated)?[_c('char-sheet-list')]:[_c('div',[_c('b-link',{attrs:{"to":"login"}},[_vm._v("Надо бы войти")])],1)]],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }